import { MenuItem } from '@shared/models/interfaces/menu-item.interface';
import { Icon } from 'cve-ui';

export const menuItems: MenuItem[] = [
    // {
    //     name: 'menu.dashboard',
    //     navigateType: 'internal',
    //     url: 'dashboard',
    //     icon: Icon.dashboard,
    //     active: true,
    //     hover: false,
    //     track: 'click_menu_dashboard',
    // },
    {
        name: 'menu.vehicles',
        navigateType: 'internal',
        url: 'vehicles',
        icon: Icon.vehicle,
        active: false,
        hover: false,
        track: 'click_menu_vehicles',
        iconPath: 'icons/car-icon.png',
    },
    {
        name: 'menu.activity',
        navigateType: 'internal',
        url: 'trips',
        icon: Icon.activity,
        active: false,
        hover: false,
        track: 'click_menu_activity',
        iconPath: 'icons/trips-icon.png',
    },
    {
        name: 'menu.invoices',
        navigateType: 'internal',
        url: 'invoices',
        icon: Icon.creditCard,
        active: false,
        hover: false,
        track: 'click_menu_payments',
        iconPath: 'icons/invoice-icon.png',
    },
    {
        name: 'menu.settings',
        navigateType: 'internal',
        url: 'settings',
        icon: Icon.configuration,
        active: false,
        hover: false,
        track: 'click_menu_settings',
        iconPath: 'icons/settings-icon.png',
    },
    {
        name: 'menu.help_center',
        navigateType: 'newTab',
        url: 'https://nextpass.io/help-center',
        icon: Icon.help,
        active: false,
        hover: false,
        track: 'click_menu_help_center',
        iconPath: 'icons/support-icon.png',
    },
];
